import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.services";
import { TOAST_SUCCESS } from "../../config/common";

export const getCategoryListApiCall = createAsyncThunk("categoryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: categoryList } = await API.getCategoryListAPI(submitData);
        dispatch(setLoader(false))
        return categoryList;
    } catch (error) {
        throw error;
    }
});

export const editCategoryDataApiCall = createAsyncThunk("editCategoryData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editCategoryData, code, message } = await API.editCategoryDataAPI(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editCategoryData, code, message };
    } catch (error) {
        throw error;
    }
});

export const getSubCategoryListApiCall = createAsyncThunk("subCategoryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: subCategoryList } = await API.getSubCategoryListAPI(submitData);
        dispatch(setLoader(false))
        return subCategoryList;
    } catch (error) {
        throw error;
    }
});

export const editSubCategoryDataApiCall = createAsyncThunk("editSubCategoryData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editSubCategoryData, code, message } = await API.editSubCategoryDataAPI(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editSubCategoryData, code, message };
    } catch (error) {
        throw error;
    }
});

export const getCategoryWiseSubCategoryListApiCall = createAsyncThunk("categoryWishSubCategoryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: categoryWishSubCategoryList, code } = await API.getCategoryWiseSubCategoryListAPI(submitData);
        dispatch(setLoader(false))
        return { data: categoryWishSubCategoryList, code };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    categoryList: {
        data: [],
        error: null,
    },
    editCategoryData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
    subCategoryList: {
        data: [],
        error: null,
    },
    editSubCategoryData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
    categoryWishSubCategoryList: {
        data: [],
        code: '',
        error: null,
    },
};

const categorySlice = createSlice({
    name: "categorySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategoryListApiCall.fulfilled, (state, action) => {
                state.categoryList.data = action.payload;
            })
            .addCase(getCategoryListApiCall.rejected, (state, action) => {
                state.categoryList.error = action.error.message;
            })
            .addCase(editCategoryDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editCategoryData.data = data;
                state.editCategoryData.message = message;
                state.editCategoryData.code = code;
            })
            .addCase(editCategoryDataApiCall.rejected, (state, action) => {
                state.editCategoryData.error = action.error.message;
            })
            .addCase(getSubCategoryListApiCall.fulfilled, (state, action) => {
                state.subCategoryList.data = action.payload;
            })
            .addCase(getSubCategoryListApiCall.rejected, (state, action) => {
                state.subCategoryList.error = action.error.message;
            })
            .addCase(editSubCategoryDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editSubCategoryData.data = data;
                state.editSubCategoryData.message = message;
                state.editSubCategoryData.code = code;
            })
            .addCase(editSubCategoryDataApiCall.rejected, (state, action) => {
                state.editSubCategoryData.error = action.error.message;
            })
            .addCase(getCategoryWiseSubCategoryListApiCall.fulfilled, (state, action) => {
                const { code, data } = action.payload;
                state.categoryWishSubCategoryList.data = data;
                state.categoryWishSubCategoryList.code = code;
            })
            .addCase(getCategoryWiseSubCategoryListApiCall.rejected, (state, action) => {
                state.categoryWishSubCategoryList.error = action.error.message;
            });
    },
});

export default categorySlice.reducer;